var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDgIcon40248Pm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FF9316"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3160_2767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3160_2767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.00007H31.9999V32H8V8.00007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9766 31.9766V8.02344H8.02344V31.9766H31.9766Z",
    stroke: "white",
    strokeWidth: 0.0468749
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3160_2767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7281 21.5064V22.0694C14.1825 21.9286 13.6594 21.7116 13.1744 21.4247L11.9739 22.625L9.84373 20.4949L11.0442 19.2945C10.7572 18.8095 10.5402 18.2865 10.3995 17.7408H8.70312V14.7283H10.3995C10.5403 14.1826 10.7573 13.6596 11.0442 13.1746L9.84373 11.9742L11.9739 9.84405L13.1744 11.0445C13.6594 10.7575 14.1824 10.5405 14.7281 10.3998V8.70331H17.7406V10.3998C18.2862 10.5405 18.8093 10.7576 19.2943 11.0445L20.4948 9.84405L22.625 11.9742L21.4245 13.1746C21.7115 13.6595 21.9285 14.1826 22.0692 14.7283H21.5062V16.4028C20.7613 16.5723 20.0507 16.8671 19.4046 17.2748L18.2196 16.0896L16.0894 18.2198L17.2744 19.4049C16.8669 20.051 16.5721 20.7616 16.4027 21.5064H14.7281Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0125 19.2471C25.0907 19.2471 26.7781 20.9344 26.7781 23.0127C26.7781 25.0911 25.0907 26.7783 23.0125 26.7783C20.9342 26.7783 19.2469 25.0911 19.2469 23.0127C19.2469 20.9344 20.9342 19.2471 23.0125 19.2471Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0146 19.1448C16.7601 19.2129 16.4978 19.2472 16.2343 19.2471C14.5719 19.2471 13.2219 17.8972 13.2219 16.2346C13.2219 14.5719 14.5719 13.2221 16.2343 13.2221C17.8969 13.2221 19.2468 14.5719 19.2468 16.2346C19.2468 16.5042 19.2114 16.7657 19.1448 17.0147L18.2196 16.0896L16.0894 18.2199L17.0146 19.1448Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5187 16.4027C25.2636 16.5722 25.9742 16.867 26.6203 17.2747L27.8053 16.0895L29.9356 18.2197L28.7505 19.4048C29.158 20.0508 29.4528 20.7615 29.6222 21.5063H31.2968V24.5188H29.6222C29.4528 25.2636 29.158 25.9743 28.7505 26.6203L29.9356 27.8054L27.8053 29.9355L26.6203 28.7504C25.9742 29.1581 25.2636 29.4529 24.5187 29.6224V31.2969H21.5062V29.6224C20.7613 29.4529 20.0507 29.158 19.4046 28.7504L18.2196 29.9355L16.0894 27.8054L17.2744 26.6203C16.8669 25.9743 16.5721 25.2636 16.4027 24.5188H14.7281V21.5063H16.4027C16.5721 20.7615 16.8669 20.0508 17.2744 19.4048L16.0894 18.2197L18.2196 16.0895L19.4046 17.2747C20.0507 16.867 20.7613 16.5722 21.5062 16.4027V14.7282H24.5187V16.4027Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3160_2767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgIcon40248Pm);
export default __webpack_public_path__ + "static/media/DGIcon 4.02.48 PM.8c863db03f3e49c28bdd1fa9086ee16c.svg";
export { ForwardRef as ReactComponent };